import React, { useEffect, useState } from "react";
import { Icon, Popconfirm } from "antd";

import { CrossIcon } from "../../../../resource/icons";

import "./loaded-file-text.scss";
import useAllowChanges from "../../hooks/useAllowChanges";

const cutText = (str) => {
	if (typeof str !== "string") {
		return str;
	}
	if (str.length < 50) {
		return str;
	}
	return (
		str.substr(0, 25).trim() +
		"..." +
		str.substr(str.length - 25, str.length).trim()
	);
};

const LoadedFileText = ({ uploadedFileText, onDelete, onSave }) => {
	const changeable = useAllowChanges();
	const [showConfirm, setShowConfirm] = useState();

	useEffect(() => {
		if (changeable) {
			const listener = () => {
				setShowConfirm(false);
			};
			document
				.getElementsByClassName("NewVoting")[0]
				.addEventListener("scroll", listener);
			document.body.addEventListener("click", listener);
			return () => {
				document
					.getElementsByClassName("NewVoting")[0]
					.removeEventListener("scroll", listener);
				document.body.removeEventListener("click", listener);
			};
		}
	}, [changeable]);
	return (
		<>
			{uploadedFileText && (
				<span
					className={`loaded-file ${
						changeable
							? "loaded-file-editing-voting"
							: "loaded-file-displaying-voting"
					}`}
				>
					<Icon type="file-text" className="file-icon" />
					<span onClick={onSave} className="file-text">
						{cutText(uploadedFileText)}
					</span>
					{changeable && (
						<Popconfirm
							visible={showConfirm}
							placement="top"
							title={"Удалить файл?"}
							onConfirm={() => {
								onDelete();
								setShowConfirm(false);
							}}
							onCancel={() => {
								setShowConfirm(false);
							}}
							okText="Да"
							cancelText="Нет"
						>
							<CrossIcon
								className="delete-icon"
								onClick={() => setShowConfirm(true)}
							/>
						</Popconfirm>
					)}
				</span>
			)}
		</>
	);
};

export default LoadedFileText;
